import React from "react";

export function formatExpirationDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return value || "Expiration pending";
  return new Date(`${value}T12:00:00`).toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric",
  });
}

const riskFlagLabels = {
  PREMIUM_PROTECTION: "Premium Protection",
  EXPANSION_RISK: "Expansion Risk",
  WEAK_REVISIONS: "Weak Earnings Revisions",
  DIVERGENCE: "Divergence Risk",
  TIMEFRAME_DIVERGENCE: "Timeframe Divergence",
  EXHAUSTION_RISK: "Exhaustion Risk",
  SQUEEZE_RISK: "Squeeze Risk",
};

function contractLabel(play) {
  const leg = play?.long_leg;
  if (!leg?.expiration || leg?.strike == null || !leg?.option_type) return null;
  const expiration = new Date(`${leg.expiration}T12:00:00`).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });
  return `${expiration} · $${leg.strike} ${leg.option_type}`;
}

export default function GuruPlayMakerResult({ result, onView }) {
  if (!result) return null;
  if (result.publication_state) {
    const spread = result.structure?.includes("Vertical");
    return <section className="guru-playmaker-result" aria-label="Guru PlayMaker result" style={{padding:14,border:"1px solid #0ea5e9",borderRadius:14,background:"#0d1929",color:"#f8fafc"}}>
      <div className="guru-playmaker-result__eyebrow">GURU PLAYMAKER</div>
      <strong>{result.ticker} — {spread ? `${result.direction} SPREAD` : result.direction}</strong>
      <div>{formatExpirationDate(result.expiration)}</div>
      {spread ? <div>BUY ${result.long_strike} {result.direction}<br/>SELL ${result.short_strike} {result.direction}</div> : <div>${result.selected_strike ?? result.long_strike} {result.direction}</div>}
      <div>STATUS · {result.status}</div>
      <div>RISK · {result.guru_risk || "NOT RATED"}</div>
      {(result.price_objectives || result.attack_levels || []).map((level,i)=>level !== "" && level != null ? <div key={i}>P{i+1} · ${String(level)}</div> : null)}
      {(result.public_risk_flags || []).map((flag)=><div key={flag}>{riskFlagLabels[flag] || flag}</div>)}
      <div>SOURCE · {result.source}</div>{result.public_note && <div>GURU VIEW · {result.public_note}</div>}
      {onView && <button type="button" onClick={onView} style={{marginTop:10}}>EDIT PLAY</button>}
    </section>;
  }
  const ready = result.status === "CONTRACT_READY";
  const label = ready ? contractLabel(result.primary_play) : null;
  const message = result.status === "NO_PLAY"
    ? "NO PLAY — CONTRACT QUALITY"
    : result.status === "INSUFFICIENT_DATA"
      ? "CONTRACT DATA UNAVAILABLE"
      : null;

  return (
    <section className="guru-playmaker-result" aria-label="Guru PlayMaker result">
      <div className="guru-playmaker-result__eyebrow">GURU PLAYMAKER</div>
      {message ? <strong>{message}</strong> : (
        <>
          <div className="guru-playmaker-result__eyebrow">PRIMARY PLAY</div>
          <strong>{label || "CONTRACT DATA UNAVAILABLE"}</strong>
          <dl>
            <div><dt>Structure</dt><dd>{result.primary_play?.structure}</dd></div>
            <div><dt>Contract Score</dt><dd>{result.scores?.overall ?? "—"} / 100</dd></div>
            <div><dt>Expiration</dt><dd>{result.primary_play?.expiration} · {result.primary_play?.DTE} DTE</dd></div>
          </dl>
        </>
      )}
      {onView && <button type="button" onClick={onView}>VIEW PLAYMAKER</button>}
    </section>
  );
}
